import React from 'react';
import PingStatus from './PingStatus';

export default function ZDashboard() {
  return (
    <PingStatus
      pingUrl="https://v1-csapi.compsoft.com.br:825/ping"
      restartKey="dashboard"
      interval={20000}
    />
  );
}
